(function () {
  function init() {
    document.querySelectorAll('[data-product-info-tabs]').forEach(function (root) {
      if (root.dataset.infoTabsReady) return;
      root.dataset.infoTabsReady = 'true';
      var nav = root.querySelector('.btan-info-tabs__nav');
      var buttons = Array.prototype.slice.call(nav.querySelectorAll('.btan-info-tabs__nav-item'));
      var marker = nav.querySelector('.marker');
      var selected = 0;
      var expanded = buttons.map(function () { return false; });
      var slider = null;
      var mobile = null;
      function panels() { return Array.prototype.slice.call(root.querySelectorAll('.btan-info-tabs__tab')); }
      function update() {
        nav.setAttribute('role', mobile ? 'presentation' : 'tablist');
        buttons.forEach(function (button, index) {
          var active = index === selected;
          button.classList.toggle('active', active);
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
        });
        panels().forEach(function (panel, index) {
          var toggle = panel.querySelector('.btan-info-tabs__tab-mobile-toggle');
          var content = panel.querySelector('.collapsible');
          var inert = Object.getOwnPropertyDescriptor(Element.prototype, 'inert');
          if (inert && inert.set) inert.set.call(panel, !mobile && index !== selected);
          else panel.inert = !mobile && index !== selected;
          // Slider restoration creates fresh nodes; clear native inert state too.
          if (mobile || index === selected) panel.removeAttribute('inert');
          else panel.setAttribute('inert', '');
          toggle.tabIndex = mobile ? 0 : -1;
          if (mobile) {
            panel.removeAttribute('role');
            panel.removeAttribute('aria-hidden');
            panel.removeAttribute('aria-labelledby');
          } else {
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', buttons[index].id);
            panel.setAttribute('aria-hidden', String(index !== selected));
          }
          toggle.classList.toggle('active', expanded[index]);
          toggle.setAttribute('aria-expanded', String(expanded[index]));
          content.hidden = mobile && !expanded[index];
          content.style.display = mobile ? (expanded[index] ? 'block' : 'none') : '';
        });
        if (!mobile) {
          var active = buttons[selected];
          marker.style.width = active.offsetWidth + 16 + 'px';
          marker.style.left = active.offsetLeft - 8 + 'px';
          marker.textContent = active.textContent.trim();
          marker.style.opacity = '1';
        }
      }
      function select(index, focus) {
        selected = index;
        if (slider) slider.goTo(index);
        update();
        if (focus) buttons[index].focus();
      }
      root.addEventListener('click', function (event) {
        var button = event.target.closest('.btan-info-tabs__nav-item');
        if (button && !mobile) { select(buttons.indexOf(button), false); return; }
        var toggle = event.target.closest('.btan-info-tabs__tab-mobile-toggle');
        if (!toggle || !mobile) return;
        var index = panels().indexOf(toggle.closest('.btan-info-tabs__tab'));
        expanded[index] = !expanded[index];
        if (expanded[index]) selected = index;
        update();
      });
      nav.addEventListener('keydown', function (event) {
        var index = buttons.indexOf(event.target);
        if (index < 0 || mobile) return;
        if (event.key === 'ArrowRight') index = (index + 1) % buttons.length;
        else if (event.key === 'ArrowLeft') index = (index + buttons.length - 1) % buttons.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = buttons.length - 1;
        else return;
        event.preventDefault();
        select(index, true);
      });
      function resize() {
        var nextMobile = window.matchMedia('(max-width: 600px)').matches;
        var focused = document.activeElement;
        var focusNav = buttons.indexOf(focused) >= 0;
        var focusToggle = focused && focused.matches('.btan-info-tabs__tab-mobile-toggle') && root.contains(focused);
        var changed = mobile !== nextMobile;
        if (nextMobile && slider) { slider.destroy(); slider = null; }
        mobile = nextMobile;
        if (!mobile && !slider && typeof tns === 'function') {
          slider = tns({
            container: root.querySelector('.btan-info-tabs__tabs'),
            items: 1, slideBy: 'page', startIndex: selected,
            loop: false, rewind: false, autoplay: false,
            controls: false, nav: false, mouseDrag: false,
            speed: 400, autoHeight: true
          });
        }
        update();
        if (changed && mobile && focusNav) panels()[selected].querySelector('.btan-info-tabs__tab-mobile-toggle').focus({ preventScroll: true });
        if (changed && !mobile && focusToggle) buttons[selected].focus({ preventScroll: true });
      }
      resize();
      window.addEventListener('resize', resize);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
